export default __webpack_public_path__ + "locales/zh-CN/SocialAuthWelcomeDialog.json?hash=a44e58aa567bdcbad1869f11fc8121d6";